__turbopack_context__.v({
  "global-error-debug": "global-error-debug-component-module-scss-module__iVq9BG__global-error-debug",
});
